import React from 'react';

import DrawerToggler from './../SideDrawer/DrawerToggler/DrawerToggler';
import NavigationItems from './../NavigationItems/NavigationItems';

import classes from './Toolbar.css';

const toolbar = (props) => (
    <header className={classes.Toolbar}>
        <DrawerToggler clicked={props.drawerTogglerClicked}/>
        <div className={classes.Logo} style={{marginTop: '5px'}}>
            <b style={{color: 'orange', 'fontSize': '28px'}}>Vocaldemy</b>
        </div>
        <nav className={classes.DesktopOnly}>
            <NavigationItems />
        </nav>
    </header>
)

export default toolbar;